import { render, staticRenderFns } from "./ItemsFooter.vue?vue&type=template&id=4d881ca4&scoped=true&"
import script from "./ItemsFooter.vue?vue&type=script&lang=js&"
export * from "./ItemsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d881ca4",
  null
  
)

export default component.exports